export const API = {
  track: (payload) => window.mp.track(payload.name, payload.data || {}, payload.options || {}),
  profile: (payload) => window.mp.people.set(payload.data),
  identify: (payload) => window.mp.identify(payload.data),
  register: (payload) => window.mp.register(payload.data),
}

function trackLink(currentTarget) {
  API.track({
    name: 'Click', data: {
      'Category': currentTarget.getAttribute('data-track'),
      'Label': currentTarget.getAttribute('data-track-label'),
      'Action': currentTarget.getAttribute('data-track-action'),
    }, options: { send_immediately: true },
  })
}

// eslint-disable-next-line complexity
function closestTrackBinding(element) {
  do {
    if (element.matches('[data-track]')) {
      return element
    }

    element = element.parentElement || element.parentNode
  } while (element !== null && element.nodeType === 1)

  return null
}

function startTrackClick() {
  window.addEventListener('click', (event) => {
    const target = closestTrackBinding(event.target)
    const targetEvent = target && target.getAttribute('data-track')

    if (!targetEvent) {
      return
    }

    trackLink(target)
  }, false)
}


function init(instance) {
  const events = window.tpn.events || []

  if (!window.tpn.keys.mixpanel_track) {
    return false
  }

  if (!window.tpn.keys.mixpanel) {
    // eslint-disable-next-line no-console
    console.error('TRACK: No Token Configured')

    return false
  }

  instance.init(window.tpn.keys.mixpanel)

  instance.register({
    'Platform': 'Web',
    'Page Name': document.title,
  })

  window.onload = () => {
    for (let idx = 0; idx < events.length; idx++) {
      const event = events[idx]

      if (API[event.action]) {
        API[event.action](event.payload)
      } else {
        // eslint-disable-next-line no-console
        console.error(`TRACK: ${event.action} is not defined`)
      }
    }

    API.track({ name: 'Page View' })
    startTrackClick()
  }

  window.addEventListener('phx:page-loading-stop', ({ detail }) => {
    const session = document.querySelector('[data-analytics-mp-id]')

    if (session) {
      session.value = instance.get_distinct_id()
    }

    if (detail.kind === 'redirect') {
      API.track({ name: 'Page View' })
    }
  })

  window.addEventListener('phx:search:track', ({ detail }) => {
    API.track({
      name: 'Search', data: {
        service: 'APP',
        ...detail,
      },
    })
  })

  return true
}

export function load() {
  import('mixpanel-browser').then((library) => {
    window.mp = library.default
    init(window.mp)
  })
}
